import coverFront from '../../../img/cover_web.webp';
import hcwFront from '../../../img/psdw.webp';
import footageChernobyl from '../../../img/footage-chernobyl.webp';
import footageIcbm from '../../../img/footage-icbm.webp';
import footageEater from '../../../img/footage-eater.webp';
import footageRetaliation from '../../../img/footage-retaliation.webp';
import { BIKINI_RELEASE_ID, HCW_RELEASE_ID } from '@/app/lib/constants';

export const BIKINI_BANDCAMP_URL = 'https://fatalexposure.bandcamp.com/';

export type FeaturedVideo = {
  url: string;
  title: string;
  poster: string;
  posterWidth: number;
  posterHeight: number;
};

export const bikiniVideos: FeaturedVideo[] = [
  {
    url: 'https://www.youtube.com/watch?v=ylLR0TmE8f0',
    title: 'Chernobyl',
    poster: footageChernobyl,
    posterWidth: 960,
    posterHeight: 540,
  },
  {
    url: 'https://www.youtube.com/watch?v=JszqNBJozag',
    title: 'ICBM 2.0',
    poster: footageIcbm,
    posterWidth: 1280,
    posterHeight: 720,
  },
  {
    url: 'https://www.youtube.com/watch?v=Ro-oi2_KNi4',
    title: 'Eater of Mankind',
    poster: footageEater,
    posterWidth: 1280,
    posterHeight: 720,
  },
  {
    url: 'https://www.youtube.com/watch?v=t0OVM-8ZTOw',
    title: 'Catastrophic Retaliation',
    poster: footageRetaliation,
    posterWidth: 640,
    posterHeight: 480,
  },
];

export const bikiniFeature = {
  id: BIKINI_RELEASE_ID,
  coverImage: coverFront,
  coverWidth: 670,
  coverHeight: 670,
  externalUrl: BIKINI_BANDCAMP_URL,
  videos: bikiniVideos,
};

export const hcwFeature = {
  id: HCW_RELEASE_ID,
  coverImage: hcwFront,
  coverWidth: 900,
  coverHeight: 900,
};
